import { useCallback } from 'react';

import { useRouter } from 'next/router';

import { StepComponentAnimator, StepContainer } from '@/common/multi-step-flow';

import { ChatBotUsingQuestionnaire } from '@ui-furniture/common/questionnaire/chat-bot-using-questionnaire';
import {
  ReservationAgreementQuestionnaireData,
  useRaQuestionnaire,
} from '@ui-furniture/common/questionnaires/use-ra-questionnaire';
import { Text } from '@ui-furniture/elements';

import { useRAContext } from '../hooks/use-ra-context';

export const CreateChatbot = () => {
  const { createDraftPolicy } = useRAContext();
  const { push } = useRouter();

  const submit = useCallback(
    async (data: ReservationAgreementQuestionnaireData) => {
      const policy = await createDraftPolicy(data);

      if (policy) {
        await push(`/protect/view/${policy.id}`);
      }
      return true;
    },
    [push]
  );
  const raQuestionnaire = useRaQuestionnaire({
    submit,
  });

  return (
    <StepContainer overflow='unset' variant='screenHeight' maxH='900px'>
      <StepComponentAnimator>
        <Text variant='title' as='h2'>
          Your Details
        </Text>
        <Text>We need a few details to personalise your policy</Text>
      </StepComponentAnimator>
      <StepComponentAnimator display='flex' flex='1' overflow='hidden' w='100%'>
        <ChatBotUsingQuestionnaire<
          Partial<ReservationAgreementQuestionnaireData>
        >
          questionnaire={raQuestionnaire}
          initialData={{}}
        />
      </StepComponentAnimator>
    </StepContainer>
  );
};
